import { format } from 'date-fns';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import constants from '../constants';
import { formatBirthDate } from './util';

const USDollar = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

const InvoicingRow = ({
	item,
	lineItemMutation,
	variant = 'ilos',
	index,
	total,
}) => {
	const [actualCost, setActualCost] = useState(item.actual_cost ?? '');
	const isModal = variant === 'modal';
	const canFulfill = isEmpty(item.fulfilled_dttm);
	const isAuthorized = !isEmpty(item.ilos_authorized_service);

	const actualCostCell = isEmpty(item.fulfilled_dttm) ? (
		<label className="flex items-center gap-1 input input-xs input-bordered">
			$
			<input
				type="number"
				min="0"
				step="0.01"
				className="w-[6ch]"
				value={actualCost}
				onChange={({ target }) => setActualCost(target.value)}
			/>
		</label>
	) : (
		USDollar.format(item.actual_cost)
	);

	const fulfilledDateCell =
		!isEmpty(item.fulfilled_dttm) && format(new Date(item.fulfilled_dttm), 'P');

	const fulfillmentStatusCell =
		!isEmpty(item.fulfilled_status) &&
		constants.fulfillmentStatus[item.fulfilled_status];

	const fulfillCell = canFulfill && (
		<details className="dropdown dropdown-end">
			<summary className="btn btn-xs btn-primary">Complete?</summary>
			<ul className="menu dropdown-content bg-white rounded-box z-[1] w-52 p-2 shadow">
				{isAuthorized && (
					<li>
						<a
							onClick={() =>
								lineItemMutation.mutate({
									...item,
									actualCost,
									status: 'FULFILLED',
								})
							}
						>
							Fulfilled - Reimbursable
						</a>
					</li>
				)}
				<li>
					<a
						onClick={() =>
							lineItemMutation.mutate({
								...item,
								actualCost,
								status: 'NOT_REIMBURSEABLE',
							})
						}
					>
						Fulfilled - Not Reimbursable
					</a>
				</li>
				<li>
					<a
						onClick={() =>
							lineItemMutation.mutate({
								...item,
								actualCost,
								status: 'NOT_ELIGIBLE',
							})
						}
					>
						Not Fulfilled - Not Eligible
					</a>
				</li>
			</ul>
		</details>
	);

	if (isModal) {
		return (
			<tr>
				<td>
					{index + 1} of {total}
				</td>
				<td>
					{item.taxonomy_sku.sku_number} {item.taxonomy_sku.label}
				</td>
				<td>{format(new Date(item.incurred_dttm), 'P')}</td>
				<td>
					{item.ilos_authorized_service?.service_unit_cost
						? USDollar.format(item.ilos_authorized_service.service_unit_cost)
						: 'N/A'}
				</td>
				<td>{actualCostCell}</td>
				<td>{fulfilledDateCell}</td>
				<td>{fulfillmentStatusCell}</td>
				<td>{fulfillCell}</td>
			</tr>
		);
	}

	return (
		<tr>
			<td>
				<Link
					to={`/worklist/application/${item.request_id}`}
					className="link link-primary"
				>
					{item.request_id}
				</Link>
			</td>
			<td>{format(new Date(item.incurred_dttm), 'P')}</td>
			<td>{item.request.external_211_service.data.name}</td>
			<td>
				{item.request.client.name_last}, {item.request.client.name_first}
			</td>
			<td>{formatBirthDate(item.request.client.birth_dttm)}</td>
			<td>
				{item?.taxonomy_sku?.sku_number} {item?.taxonomy_sku?.label}
			</td>
			<td>
				{item?.ilos_authorized_service
					? constants.durationUnits[item.ilos_authorized_service.duration_unit]
					: 'N/A'}
			</td>
			<td>
				{item?.ilos_authorized_service
					? USDollar.format(item.ilos_authorized_service.service_unit_cost)
					: 'N/A'}
			</td>
			<td>{actualCostCell}</td>
			<td>{fulfilledDateCell}</td>
			<td>{fulfillmentStatusCell}</td>
			<td>{fulfillCell}</td>
		</tr>
	);
};

InvoicingRow.propTypes = {
	item: PropTypes.object.isRequired,
	lineItemMutation: PropTypes.object.isRequired,
	variant: PropTypes.oneOf(['ilos', 'modal']),
	index: PropTypes.number,
	total: PropTypes.number,
};

export default InvoicingRow;
